import PropTypes from "prop-types"
import { Fab } from "@mui/material"
import { Search } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"

export default function SearchButton({ onClick, noModels }) {
  let searchProps = { disabled: noModels }
  let tooltip = "Search is disabled since you do not have access to any risk model."
  if (!noModels) {
    searchProps = {
      ...searchProps,
      color: "primary",
      onClick,
    }
    tooltip = "Search"
  }
  return <div className="search-button">
    <Tooltip title={tooltip}>
      <span>
        <Fab {...searchProps}>
          <Search />
        </Fab>
      </span>
    </Tooltip>
  </div>
}

SearchButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  noModels: PropTypes.bool.isRequired,
}
